<div class="item-panel">
	<div class="heading strong">
		<b>FDM + EXCEEDANCES</b>
	</div>
	<div class="content">
		<div class="row">
			<label class="col-md-2 col-form-label">Operation:</label>
			<div class="col-md-4">
				<select class="form-control form-control-sm op-list" [(ngModel)]="selectedOperation"
					title="Showing {{ operations && operations.length >= 800 ? 'latest 800' : 'all' }} operations{{ onlyExceedances ? ' with exceedances' : '' }}{{ showEmpty ? '' : ' with rotor turn time > 2 minutes or not known' }}">
					<option *ngFor="let operation of operations" [ngValue]="operation"
						[ngClass]="{ 'unacked-ex' : operation.exceedance_count > 0 && !operation.exceedance_ack_by, 'acked-ex': operation.exceedance_count > 0 && operation.exceedance_ack_by, 'no-ex': operation.exceedance_count === 0 }">
						{{operation.start_time | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0)}}{{operation.rotor_turn_time |
						runtime : " Rotor: "}}{{operation.flight_time | runtime : " Flight: "}}{{operation.exceedance_count > 0 ? "
						Ex: " + operation.exceedance_count : ""}}{{operation.exceedance_count && operation.exceedance_ack_by ? "
						(ack)" : ""}}
					</option>
				</select>
			</div>
			<div class="col-md-5">
				<label class="col-form-label">
					<input [(ngModel)]="onlyExceedances" (ngModelChange)="updateOperations()" type="checkbox">
					Only operations with exceedances
				</label>
				<div *ngIf="api.user.role === 'admin' || api.user.role === 'master'" title="Show empty ops (ADMIN ONLY)">
					<label class="col-form-label">
						<input [(ngModel)]="showEmpty" (ngModelChange)="updateOperations()" type="checkbox">
						Show empty operations
					</label>
				</div>
			</div>
		</div>
	</div>
	<div class="content nopad">
		<div *ngIf="selectedOperation">
			<ul ngbNav #nav="ngbNav" class="nav-tabs dark">
				<li ngbNavItem>
					<a ngbNavLink>FDM + Exceedances</a>
					<ng-template ngbNavContent>
						<app-exceedances [fleet]="fleet" [asset]="asset" [components]="components" [operation]="selectedOperation"></app-exceedances>
					</ng-template>
				</li>
				<li ngbNavItem>
					<a ngbNavLink>Flight Playback</a>
					<ng-template ngbNavContent>
						<app-flight-map [fleet]="fleet" [asset]="asset" [operation]="selectedOperation"></app-flight-map>
					</ng-template>
				</li>
			</ul>
			<div [ngbNavOutlet]="nav"></div>
		</div>
	</div>
</div>